import type { FC } from 'react';

import { useLeafRouteParams } from '../../router/use_leaf_route_params';
import Tabs, { type Tab } from '../../ui/tabs/tabs';
import { matchPath } from '../../utils/match_path';

export type RouteTab = Tab & {
  href: string;
  route: string;
};

type Props = {
  tabs: RouteTab[];
  hideIfNotMatched?: boolean;
};

export const RouteTabs: FC<Props> = ({ tabs, hideIfNotMatched = false }) => {
  const { route: currentRoute } = useLeafRouteParams();
  const activeTab = tabs.findIndex(
    (tab) =>
      tab.route && matchPath(tab.route, { path: currentRoute, exact: true }),
  );

  if (activeTab === -1 && hideIfNotMatched) {
    return null;
  }

  return <Tabs tabs={tabs} activeTab={activeTab} />;
};
